export default __webpack_public_path__ + "static/media/info2.0040ecc3.webp";